import React from 'react';
import {Checkbox, Icon, Text} from '@mc/ui-v4';
import {mcDropDown} from '@mc/react-ui-icons';
import {CiselnikFilterNode} from './filterTreeTypes';
import {UseFilterTreeResult} from './useFilterTree';

type Props = {
    node: CiselnikFilterNode;
    depth: number;
    tree: UseFilterTreeResult;
};

/**
 * Jeden řádek stromového filtru – rekurzivně vykreslí i své potomky.
 * Kategorie (uzel s potomky) má vpravo chevron pro rozbalení a jeho checkbox
 * může být v „indeterminate" stavu (částečný výběr potomků).
 */
export const FilterTreeItem: React.FC<Props> = ({node, depth, tree}) => {
    const {getState, toggleNode, toggleExpanded, expandedIds} = tree;
    const hasChildren = !!node.children && node.children.length > 0;
    const expanded = expandedIds.has(node.id);
    const state = getState(node);

    const isRoot = depth === 0;

    return (
        <div className={`filter-tree-node${isRoot ? ' filter-tree-node--root' : ''}`}>
            <div
                className={`filter-tree-row`}
                onClick={() => (hasChildren ? toggleExpanded(node.id) : toggleNode(node))}
                style={{paddingLeft: 10 + depth * 22}}
            >
                <Checkbox
                    checked={state === 'checked'}
                    indeterminate={state === 'indeterminate'}
                    onChange={() => toggleNode(node)}
                    // zaškrtnutí jen po kliknutí na checkbox – zbytek řádku u kategorie sbaluje/rozbaluje (viz onClick řádku)
                    onClick={(e: React.MouseEvent) => e.stopPropagation()}
                />

                {isRoot && node.color && (
                    <span className={'filter-tree-dot'} style={{backgroundColor: node.color}}>
                        {node.icon && <Icon icon={node.icon} />}
                    </span>
                )}

                {node.iconUrl && <img className={'filter-tree-layer-icon'} src={node.iconUrl} alt={''} loading={'lazy'} />}

                <Text type={'value'} className={'filter-tree-label'} style={node.labelColor ? {color: node.labelColor} : undefined}>
                    {node.label}
                </Text>

                {hasChildren && (
                    <button
                        type={'button'}
                        className={'filter-tree-chevron'}
                        title={expanded ? 'Sbalit' : 'Rozbalit'}
                        onClick={(e: React.MouseEvent) => {
                            e.stopPropagation();
                            toggleExpanded(node.id);
                        }}
                    >
                        <Icon icon={mcDropDown} style={{transform: expanded ? undefined : 'rotate(-90deg)', transition: 'transform 0.2s'}} />
                    </button>
                )}
            </div>

            {hasChildren && expanded && (
                <div className={'filter-tree-children'}>
                    {node.children!.map(child => (
                        <FilterTreeItem key={child.id} node={child} depth={depth + 1} tree={tree} />
                    ))}
                </div>
            )}
        </div>
    );
};
